import React, { useContext, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import Axios from "axios";
import { StateContext } from "../App";
import "./login.css";

function ForgotPassword(props) {
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");

  // console.log("ForgotPassword component!", props);
  const { dispatch } = useContext(StateContext);

  const login_form = async (e) => {
    e.preventDefault();
    const notLoadingBtn =  document.querySelector(".not-loading-btn")
    const isLoadingBtn = document.querySelector(".btn-back")
    
    notLoadingBtn.style.display = "none";
    isLoadingBtn.style.display = "block";

      setError("");
      setMsg("");

    const form = document.querySelector(".login-form");

    const email = form.email.value;

    try {
      const result = await Axios.post("/password-reset/forgot-password", { email });
      result && console.log(result.data)

        if (result.data.error) {
            document.querySelector(".not-loading-btn").style.display = "block";
            document.querySelector(".btn-back").style.display = "none";
            setError(result.data.error);
        }
        
      if (result.data.msg) {
          document.querySelector(".not-loading-btn").style.display = "block";
          document.querySelector(".btn-back").style.display = "none";
          setMsg(result.data.msg)
        }
        
    } catch (err) {
       notLoadingBtn.style.display = "block";
       isLoadingBtn.style.display = "none";
      dispatch({ type: "SET_AUTH", payload: false });
    }
  };

  return (
    <div className="login">
      <div className="centered">
        <form className="login-form" onSubmit={login_form}>
          <h3>Account Recovery</h3>
          <span className="error">{error}</span>
          <span className="error success-msg">{msg}</span>
          {/* username OR email */}
          <div className="input-field">
            <input className="email-input" type="text" name="email" placeholder="Enter your email" />
          </div>
          <div className="input-field">
            <button className="not-loading-btn">login</button>
            <div className="btn-back">
              <button disabled className="loading-btn">
                <div id="loader"></div>
              </button>
            </div>
          </div>
          <div className="action-btn grey-text darken-3">
            <span>don't have an account?</span>
            <Link to="/signup">signup</Link>
          </div>
        </form>
      </div>
      <div className="homepage-link">
        <a href="/">go to homepage</a>
      </div>
    </div>
  );
}

export default withRouter(ForgotPassword);
